import React from "react";
import { BadgeCheckIcon, StarIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { testimonials } from "../../data/content";
function Stars({
  size = "h-4 w-4"
}: {
  size?: string;
}) {
  return <div className="flex gap-0.5" aria-hidden="true" data-id="element-339" data-mp="3mg0mup53sxgg">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className={`${size} fill-[#F5B301] text-[#F5B301]`} data-id="element-340" data-mp="3r8ai8kozmpq4" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-341" data-mp="42t5hj1c15s7">
      <div className="mx-auto max-w-6xl" data-id="element-342" data-mp="4188lmrjpar6">
        <p className="text-center text-sm font-bold uppercase tracking-wide text-gold" data-id="element-343" data-mp="91w68raa4pud">Professional feedback</p>
        <h2 className="text-balance mt-3 text-center font-serif text-3xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-344" data-mp="e1imzapbgo7x">
          What surgeons are saying about the <em className="text-gold" data-id="element-345" data-mp="2av3p2ap3ppl0">Blueprint</em>
        </h2>
        <div className="mt-5 flex items-center justify-center gap-3" data-id="element-346" data-mp="2ftewyfvu5q0l">
          <Stars size="h-6 w-6" data-id="element-347" data-mp="1sk9cyl8xwmdo" />
          <span className="text-2xl font-extrabold text-ink" data-id="element-348" data-mp="1slknr50syuea">4.9/5</span>
        </div>

        <ul className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-349" data-mp="1ntkhyvy1x79s">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-3xl bg-cream p-6" data-id="element-350" data-mp="1ivj2ekzu3q32">
              <div className="flex items-center gap-4" data-id="element-351" data-mp="1etxi4ekz09iu">
                <img src={t.photo} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-white" loading="lazy" data-id="element-352" data-mp="1erbakey2xu0m" />
                <div className="min-w-0" data-id="element-353" data-mp="22i7ay0glpxjh">
                  <p className="font-bold leading-tight text-ink" data-id="element-354" data-mp="22h5o6yq83mlx">{t.name}</p>
                  <p className="mt-0.5 text-sm text-ink/60" data-id="element-355" data-mp="1xikmeuvbouvd">{t.role}</p>
                </div>
              </div>
              <div className="mt-4" data-id="element-356" data-mp="r4bixr4lluau">
                <Stars data-id="element-357" data-mp="r179ofca08db" />
              </div>
              <blockquote className="mt-3 text-[16px] leading-relaxed text-ink/85" data-id="element-358" data-mp="m3fgzj3t4i82">“{t.quote}”</blockquote>
              <p className="mt-auto flex items-center gap-1.5 pt-4 text-xs font-bold uppercase tracking-wide text-cta" data-id="element-359" data-mp="nmnrhxnhh02u">
                <BadgeCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-360" data-mp="sjxsmak8j06i" />
                Verified customer
              </p>
            </li>)}
        </ul>

        <div className="mt-12" data-id="element-361" data-mp="ilrr3u2cbw26">
          <CTAButton label="I want to use the Mastopexy Blueprint™" data-id="element-362" data-mp="ikq3kq451h3k" />
        </div>
      </div>
    </section>;
}